import { render } from "./BuyButton.vue?vue&type=template&id=0bd7e9cc&scoped=true&ts=true"
import script from "./BuyButton.vue?vue&type=script&lang=ts"
export * from "./BuyButton.vue?vue&type=script&lang=ts"

import "./BuyButton.vue?vue&type=style&index=0&id=0bd7e9cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd7e9cc"]])

export default __exports__